/* eslint-disable @typescript-eslint/no-explicit-any */
import { catchError, firstValueFrom } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { enviroment } from 'src/environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RequestFormService {

  constructor(private httpClient: HttpClient) {}

  async postRequestForms(element: any): Promise<any> {
    return firstValueFrom(
      this.httpClient.post<any>(enviroment.url + 'solicitud', element)
        .pipe(
          catchError((error: any) => {
            console.error('Error occurred:', error);
            throw error;
          })
        )
    );
  }

  async getRequestFormsId(beneficio_id: any): Promise<any> {
    const response = await firstValueFrom(
      this.httpClient.get<any[]>(
        enviroment.url + 'solicitud/' + beneficio_id + '/detalle',
      ),
    );
    return response;
  }

  async getRequestHistory(beneficio_id: any): Promise<any> {
    const response = await firstValueFrom(
       this.httpClient.get<any[]>(enviroment.url + 'history/'+ beneficio_id ),
     );
     return response;
   }

  async putRequestForms(element: any): Promise<any> {
    return firstValueFrom<any>(
      this.httpClient.put<any>(enviroment.url + 'solicitud', element),
    );
  }

  async putApplicationStatusUpdate(
    form: any,
    status: number,
    id_solicitud: number,
    beneficio_id: number,
    motivo?: string
  ) {
    try {
      // Si hay un motivo (comentario), lo agregamos al formulario según el estado
      if (motivo && motivo.trim() !== '') {
        if (status === 2) { // Estado Aprobada
          form.motivo_aprobacion = motivo;
        } else if (status === 3) { // Estado Rechazada
          form.comentario_rechazo = motivo;
        }
      }

      const request = {
        id: id_solicitud,
        estado_solicitud_id: status,
        beneficio_id: beneficio_id,
        formulario: JSON.stringify(form),
      };

      const response = await this.putRequestForms(request);
      
      if(response.statusCode === 200){
        window.location.reload();
      }

      return response;
    } catch (error) {
      console.error('Error:', error);
    }
  }

  async get_url_s3(element: any): Promise<any> {
    return firstValueFrom<any>(
      this.httpClient.post<any>(enviroment.url + 's3/get_url', element),
    );
  }

  async get_url_donwload_file(payload: any): Promise<any> {
    return firstValueFrom<any>(
      this.httpClient.post<any>(enviroment.url + 's3/download/file', payload),
    );
  }

  async execute_url(url: any): Promise<any> {
    return firstValueFrom<any>(this.httpClient.get(url));
  }

  async put_file_s3(file: File, key_name_bucket: string = 'files'): Promise<any> {
    const url_s3 = await this.get_url_s3({
      s3_object: file.name,
      key_name_bucket: key_name_bucket
    });

    const headers = new HttpHeaders({
      'Content-Type': file.type,
      Accept: '*/*',
    });

    return firstValueFrom<any>(
      this.httpClient.put(url_s3['upload_url'], file, { headers }),
    );
  }


  async montoSolicitudFormulario(key: string, id_beneficio:number): Promise<any> {
    return firstValueFrom<any>(
      this.httpClient.get<any>(enviroment.url + 'solicitud/'+ key +'/' + id_beneficio +'/monto_consumido'),
    );
  }

}
